










































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import {
  ColumnSortRequestData,
  SortedColumnInfo,
  SwTable,
  TableColumnConfig,
  TableEntry,
  TableEntryExpandingEventData,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwContentToolbar } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwDropMenu } from '@sonicwall/unified-ui-framework/src/shared/sw-drop-menu';
import { SwTextfield, SwExpandableTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwChip } from '@sonicwall/unified-ui-framework/src/shared/sw-chip';
import { VNode, CreateElement } from 'vue';
import { Component } from 'vue-property-decorator';
import { SwSelect, SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import  { MswApiService } from '@/shared/msw-api-service';
import MswOrderDetails from './components/msw-order-details.vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';

const cssPrefix = 'msw-orders';

@Component({
  components: {
    SwTable,
    SwContentToolbar,
    SwIconButton,
    SwDropMenu,
    SwExpandableTextfield,
    SwSelect,
    SwTextfield,
    SwChip,
    MswOrderDetails,
    MswAppTitle,
  },
  directives: {},
})
export default class MswOrders extends SwExtendedVue {
  cssPrefix = cssPrefix;

  tableData: TableEntry[] = [];
  filteredData: TableEntry[] = [];
  expandedEntries: Set<string> = new Set();
  shadowExpandedEntries: string[] = [];
  openFilterList: boolean = false;
  searchExpanded: boolean = false;
  searchText: string = '';
  searchTextFilter: string = '';
  filterColumnKey: string = '';
  filterColumnValue: string = '';
  selectOptions: SelectOption[] = [
    {
      id: 'recent',
      label: this.$t('orderHistory.recent')
      .toString(),
      value: 'recent',
    },
    {
      id: 'all',
      label: this.$t('orderHistory.all')
      .toString(),
      value: 'all',
    },
  ];
  selectedOption: string = 'recent';
  showColumnFilter: boolean = false;
  selectedColumnFilters: any[] = [];
  columnFilterText: string = '';
  isColFilterInEditMode: boolean = true;
  sortedColumns: SortedColumnInfo[] = [];
  get columnConfig(): TableColumnConfig[] {
    return [{
      key: 'index',
      type: 'index',
    },
    {
      key: 'expand',
      type: 'expand',
      tooltip: { content: 'expand', compact: true },
      /* tslint:disable-next-line */
      typedCellTooltip: ((entry) => {
        const expandedEntries = Array.from(this.expandedEntries);
        const selectedIcon = document.querySelector(`.expandIcon-${entry._key}`);
        if (expandedEntries?.length > 0 && expandedEntries.indexOf(entry._key) >= 0) {
          selectedIcon?.setAttribute('title', 'Collapse');
        } else {
          selectedIcon?.setAttribute('title', 'Expand');
        }
      }),
      className: ((entry) => {
        return `expandIcon-${entry._key}`;
      }),
      /* tslint:disable-next-line */
      render: (h, data): VNode => {
        return (
          <MswOrderDetails order={data.entry}/>
        ) as VNode;
      },
    },
    {
      key: 'status',
      dataKey: 'status',
      title: this.$t('orderHistory.status')
      .toString(),
      sorter: true,
      tooltip: { placement: 'bottom', content: 'expand', compact: true },
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.status;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              {data.entry.status}

              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.status && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.onSelectFilter('status');
                      this.menuItems[0].searchText = data.entry.status;
                      this.handleColSearchText(this.selectedColumnFilters.length - 1);
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key: 'orderNo',
      dataKey: 'orderNo',
      title: this.$t('orderHistory.orderNumber')
      .toString(),
      sorter: true,
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.orderNo;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              {data.entry.orderNo}

              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.orderNo && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.onSelectFilter('orderNo');
                      this.menuItems[1].searchText = data.entry.orderNo;
                      this.handleColSearchText(this.selectedColumnFilters.length - 1);
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key: 'dtDate',
      dataKey: 'dtDate',
      title: this.$t('orderHistory.Date')
      .toString(),
      sorter: true,
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.dtDate;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              {data.entry.dtDate}

              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.dtDate && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.onSelectFilter('date');
                      this.menuItems[2].searchText = data.entry.dtDate;
                      this.handleColSearchText(this.selectedColumnFilters.length - 1);
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key: 'orderType',
      dataKey: 'orderType',
      title: this.$t('orderHistory.orderType')
      .toString(),
      sorter: true,
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.orderType;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              {data.entry.orderType}

              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.orderType && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.onSelectFilter('orderType');
                      this.menuItems[3].searchText = data.entry.orderType;
                      this.handleColSearchText(this.selectedColumnFilters.length - 1);
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key: 'payment',
      dataKey: 'payment',
      title: this.$t('orderHistory.payment')
      .toString(),
      sorter: true,
    },
    {
      key: 'amount',
      dataKey: 'amount',
      title: this.$t('orderHistory.amt')
      .toString(),
      sorter: (a: TableEntry, b: TableEntry): number => {
        const num1 = Number(a.amount.split(' ')[0]);
        const num2 = Number(b.amount.split(' ')[0]);
        return num1 - num2;
      },
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.amount;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              {data.entry.amount}

              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.amount && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.onSelectFilter('amount');
                      this.menuItems[4].searchText = data.entry.amount;
                      this.handleColSearchText(this.selectedColumnFilters.length - 1);
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    }];
  }

  onEntryExpanding(data: TableEntryExpandingEventData) {
    if (data.expanding) {
      this.expandedEntries.add(data.entryKey);
    } else {
      this.expandedEntries.delete(data.entryKey);
    }
    this.shadowExpandedEntries = Array.from(this.expandedEntries);
  }

  created() {
    this.getDataFromApi();
  }

  getDataFromApi() {
    if (this.$route.query.eorderid && this.$route.query.snbuser) {
      this.getOrderDetails(this.$route.query.eorderid);
    } else {
      this.getOrderHistory();
    }
  }

  getOrderHistory() {
    this.$store.commit('startLoading');
    MswApiService.orders.getOrderHistory()
    .then((resp: any) => {
      const { orderHistoryList } = resp.content;
      this.$store.commit('stopLoading');
      this.tableData = this.getIndexedTableEntries(orderHistoryList);
      this.filteredData = this.getIndexedTableEntries(orderHistoryList);
      this.applyFilters();
    });
  }

  getOrderDetails(orderNo: any) {
    this.$store.commit('startLoading');
    MswApiService.orders.getOrderDetails(orderNo)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      this.tableData = this.fillTableDetails(resp);
      this.filteredData = this.fillTableDetails(resp);
    });
  }

  closeExpandedEntries() {
    const table = this.$refs.tableExpand as SwTable;
    const expandedRowKeys: any = table.getAllExpandedKeys();
    const filteredData: any = this.tableData?.filter(ele => expandedRowKeys?.includes(ele._key));
    for (const entry of filteredData) {
      table.claimEntryExpanded(entry, false);
    }

  }

  reload() {
    this.searchText = '';
    this.removeColFilters();
    this.getDataFromApi();
    this.closeExpandedEntries();
  }

  fillTableDetails(resp: any) {
    const tableData: any[] = [];
    const dataObj: any = {};
    const {
      orderStatus,
      orderID,
      orderDate,
      orderType,
      payment,
      totalPrice,
    } = resp.content;
    dataObj['_key'] = orderID;
    dataObj['status'] = orderStatus;
    dataObj['orderNo'] = orderID;
    dataObj['dtDate'] = orderDate;
    dataObj['orderType'] = orderType;
    dataObj['payment'] = payment;
    dataObj['amount'] = totalPrice;
    dataObj['date'] = orderDate;
    tableData.push(dataObj);
    return tableData;
  }

  getIndexedTableEntries(entries: any[]) {
    const result: any[] = [];
    entries.forEach((entry: any) => {
      result.push({ ...entry, _key: entry.orderNo });
    });
    return result;
  }

  applyFilters() {
    this.applyDateFilter(this.selectedOption);
    this.applyColumnFilters();
    this.applyTextFilter();
  }

  applyDateFilter(id: string) {
    const recentDate = new Date();
    recentDate.setDate(recentDate.getDate() - 60);
    this.filteredData = [...this.tableData];
    if (id === 'recent') {
      this.filteredData = this.tableData.filter((order) => {
        return new Date(order.date) >= recentDate;
      });
    }
  }

  menuItems: any[] = [
    {
      id: 'status',
      content: this.$t('orderHistory.status')
      .toString(),
      searchText: '',
    },
    {
      id: 'orderNo',
      content: this.$t('orderHistory.orderNumber')
      .toString(),
      searchText: '',
    },
    {
      id: 'dtDate',
      content: this.$t('orderHistory.Date')
      .toString(),
      searchText: '',
    },
    {
      id: 'orderType',
      content: this.$t('orderHistory.orderType')
      .toString(),
      searchText: '',
    },
    {
      id: 'amount',
      content: this.$t('orderHistory.amt')
      .toString(),
      searchText: '',
    },
  ];

  onSelectFilter(filter: string) {
    this.selectedColumnFilters = this.selectedColumnFilters.filter(filter => filter.isNonEditMode);
    const ftrObj = this.menuItems.filter((item) => {
      return item.id === filter &&
      this.selectedColumnFilters.findIndex(item => item.id === filter) === -1; // Ignoring duplicate column filter
    })[0];
    if (ftrObj) {
      this.selectedColumnFilters.push(ftrObj);
      this.showColumnFilter = true;
      setTimeout(
        () => {
          const refTb: any = (this.$refs.refColFilter as SwTextfield);
          refTb && refTb[0].focus();
        },
        0,
      );
    }
    this.openFilterList = false;
  }

  removeColFilter(id: number) {
    this.selectedColumnFilters[id].newSearchText = '';
    this.selectedColumnFilters[id].isNonEditMode = false;
    this.selectedColumnFilters.splice(id, 1);
    this.applyFilters();
  }

  handleColSearchText(index: any) {
    this.selectedColumnFilters[index].isNonEditMode = true;
    this.selectedColumnFilters[index].newSearchText = this.selectedColumnFilters[index].searchText;
    this.selectedColumnFilters[index].searchText = '';
    this.applyFilters();
  }

  applyColumnFilters() {
    this.selectedColumnFilters.forEach((filter: any) => {
      if (filter.isNonEditMode) {
        this.filteredData = this.filteredData.filter((item: any) => {
          return item[filter.id].toLowerCase()
          .includes(filter.newSearchText.toLowerCase());
        });
      }
    });
  }

  removeColFilters() {
    this.selectedColumnFilters.forEach((item, index) => { // tslint:disable-line
      this.selectedColumnFilters[index].newSearchText = '';
      this.selectedColumnFilters[index].isNonEditMode = false;
    });
    this.selectedColumnFilters = [];
    this.applyFilters();
  }

  applyTextFilter() {
    if (!this.searchText) {
      return;
    }
    this.searchTextFilter = this.searchText;
    const newData:any = [];
    this.filteredData.forEach((item: any) => {
      this.menuItems.forEach((filter: any) => {
        if (item[filter.id].toLowerCase()
        .includes(this.searchText.toLowerCase())) {
          newData.push(item);
        }
      });
    });
    this.searchText = '';
    this.filteredData = newData;
  }

  removeSearchFilter() {
    this.searchTextFilter = '';
    this.searchText = '';
    this.applyFilters();
  }

  onRequestSorting(data: ColumnSortRequestData) {
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.cancel) {
        this.sortedColumns.splice(index, 1);
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }
}
